enum BorrowerTypeEnum {
    Company = 'COMPANY',
    Individual = 'INDIVIDUAL',
    Trust = 'TRUST',
}

export default BorrowerTypeEnum;
